<template>
  <div class="c-total-report h-100">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="auto" md="2" sm="2" class="columns">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="showDialog('lastMonth')"
            >
              Last Month
            </div>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="columns">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="showDialog('lastWeek')"
            >
              Last Week
            </div>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="columns">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="showDialog('today')"
            >
              Today
            </div>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="columns">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="showDialog('week')"
            >
              This Week
            </div>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="columns">
            <div
              class="primary--text text-decoration-underline cursor-pointer"
              @click="showDialog('month')"
            >
              This Month
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="auto" md="2" sm="2" class="py-2 columns">
            <v-row>
              <v-col cols="auto">
                <p>{{ (totalReport.RLM || 0) | valToFixed }}</p>
                <p>{{ (totalReport.PLM || 0) | valToFixed }}</p>
              </v-col>
              <v-col cols="auto">
                <div>Reported</div>
                <div>Paid</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="py-2 columns">
            <v-row>
              <v-col cols="auto">
                <p>{{ (totalReport.RLW || 0) | valToFixed }}</p>
                <p>{{ (totalReport.PLW || 0) | valToFixed }}</p>
              </v-col>
              <v-col cols="auto">
                <div>Reported</div>
                <div>Paid</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="py-2 columns">
            <v-row>
              <v-col cols="auto">
                <p>{{ (totalReport.RD || 0) | valToFixed }}</p>
                <p>{{ (totalReport.PD || 0) | valToFixed }}</p>
              </v-col>
              <v-col cols="auto">
                <div>Reported</div>
                <div>Paid</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="py-2 columns">
            <v-row>
              <v-col cols="auto">
                <p>{{ (totalReport.RW || 0) | valToFixed }}</p>
                <p>{{ (totalReport.PW || 0) | valToFixed }}</p>
              </v-col>
              <v-col cols="auto">
                <div>Reported</div>
                <div>Paid</div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" md="2" sm="2" class="py-2 columns">
            <v-row>
              <v-col cols="auto">
                <p>{{ (totalReport.RM || 0) | valToFixed }}</p>
                <p>{{ (totalReport.PM || 0) | valToFixed }}</p>
              </v-col>
              <v-col cols="auto">
                <div>Reported</div>
                <div>Paid</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <TotalDetailsDialog
      :key="rangeFor"
      v-model="dialog"
      :rangeFor="rangeFor"
    />
  </div>
</template>
<script>

export default {
  name: 'TotalReport',
  components: {
    TotalDetailsDialog: () => import('@/components/reporting/TotalDetailsDialog.vue')
  },
  data () {
    return {
      dialog: false,
      rangeFor: 'today'
    }
  },
  computed: {
    totalReport () {
      return this.$store.getters.getTotalReport
    }
  },
  filters: {
    valToFixed (val) {
      if ((Math.ceil(val * 100) % 10) !== 0) return (+val).toFixed(2)
      if ((Math.ceil(val * 100) % 100) !== 0) return (+val).toFixed(1)
      return (+val).toFixed(0)
    }
  },
  methods: {
    showDialog (rangeFor) {
      this.rangeFor = rangeFor
      this.dialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-total-report {
    p {
      font-size: 1.0rem;
      margin: 0;
      padding: 0;
      white-space: nowrap;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .columns {
      min-width: 130px;
    }
  }
</style>
